__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.7.1-63de60b-12702/_next/";